module.exports = __webpack_public_path__ + "img/remove_account_3.f564c32a.png";